export const environment = {
  production: false,
  apiBaseUrl: 'https://develop.sf24.api.smartfit100.com/v1',
  wsBaseUrl: 'wss://develop.sf24.api.smartfit100.com/ws',
  memberUrl: 'https://develop-v4.sf24.member.smartfit100.com',
  shopId: 'tshop00041480',
  btPostUrl: 'https://www.acctrans-reg.jp/rtex/ar/nj3XA53q/',
  mulPayTokenUrl: 'https://stg.static.mul-pay.jp/ext/js/token.js',
};
